<template>
  <div class="navbar">
    <!-- <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    /> -->

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <search id="header-search" class="right-menu-item" />

        <!--<el-tooltip content="下载源码" effect="dark" placement="bottom">-->
        <!--<ruo-yi id="ruoyi" class="right-menu-item hover-effect" />-->
        <!--</el-tooltip>-->

        <el-dropdown class="right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <i class="el-icon-message-solid" />
          </div>
          <el-dropdown-menu slot="dropdown" class="dropdown-menu">
            <!-- <el-dropdown-item> -->
            <el-tabs v-model="activeName" class="notice" @tab-click="handleClick">
              <el-tab-pane label="通知" name="first">
                <el-card v-for="(data, index) in noticeData" :key="index" class="box-card">
                  <div class="text item" style="cursor: pointer;" @click="noticeList(data)">{{ data.notice_title }}</div>
                </el-card>
                <el-button class="btn" type="text" @click="btnList">查看更多</el-button>
              </el-tab-pane>
              <el-tab-pane label="公告" name="second">
                <el-card v-for="(data, index) in noticeData" :key="index" class="box-card">
                  <div class="text item" style="cursor: pointer;" @click="noticeList(data)">{{ data.notice_title }}</div>
                </el-card>
                <el-button class="btn" type="text" @click="btnList">查看更多</el-button>
              </el-tab-pane>
            </el-tabs>
            <!-- </el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>
      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="head" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/profile">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>

          <el-dropdown-item>
            <span @click="setting = true">布局设置</span>
          </el-dropdown-item>
          <el-dropdown-item divided  @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import RuoYi from '@/components/RuoYi'
import head from '../../assets/logo/avatar.jpg'
// import { getNoticeData } from '@/api/system/notice'
import { logOut } from '@/api/login'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search,
    RuoYi
  },
  data () {
    return {
      head: head,
      activeName: 'first',
      noticeData: [],
      queryParams: {
        pageNum: 1, // 页码
        pageSize: 10, // 页数
        notice_type: 1, // 1通知 2公告
        status: 0 // 0 正常 1关闭
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    setting: {
      get () {
        return this.$store.state.settings.showSettings
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  created () {
    // 获取公告数据
    // this.getNotice()
  },
  methods: {
    // 点击加载更多按钮跳转列表
    btnList () {
      this.$router.replace('/message/message')
    },
    // 点击跳转消息通知
    noticeList (item) {
      this.$router.replace('/message/message?notice_type=' + item.notice_type + '&notice_id=' + item.notice_id)
    },
    // 获取公告数据
    getNotice () {
      getNoticeData(this.queryParams).then(res => {
        this.noticeData = res.rows
      })
    },
    handleClick (tab, event) {
      this.queryParams.notice_type = tab.name == 'first' ? 1 : 2
      this.getNotice()
    },
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
   logout () {
      this.$confirm('确定要退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(res => {
        logOut().then((res) => {
          this.$store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      })

    }
  }
}
</script>

<style lang="scss" scoped>
// 按钮居中
.btn {
  margin-top: 10px;
  margin-left: 180px;
}

// 卡片
.text {
  font-size: 14px;
}

// .item {
//   padding: 18px 0;
// }

.box-card {
  width: 480px;
  border-left: 1px solid transparent;
  border-top: 1px solid transparent;
  box-shadow: 0 0 0 white;
}

.clearfix {
  font-size: 12px;
  color: red;
}

.notice {
  ::deep .el-card__body {
    padding: 10px 20px 10px 20px;
  }
}

.dropdown-menu {
  width: 500px;
  padding: 20px;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
